import Image from 'next/image'
import {FC} from 'react'

import {Text, TextFontWeight} from '@/components/common/content/Text'
import {getBlogContent} from '@/content/blog/blog'
import {Link, useTranslation} from '@/i18n'
import {HOVER_TRANSITION} from '@/theme/cssTransitions'
import {theme} from '@/theme/theme'
import {Industry} from '@/utils/contentful'
import {routeTo} from '@/utils/router'
import {MOBILE_SCREENSIZE, TABLET_SCREENSIZE} from '@/utils/styles/breakpoints'

type IndustryCardProps = {
  industry: Industry
}

export const IndustryCard: FC<React.PropsWithChildren<IndustryCardProps>> = ({
  industry: {icon, name},
}) => {
  const {t} = useTranslation()
  const {cardTitle} = getBlogContent().industries

  return (
    <>
      <li className="item">
        <Link href={routeTo.blog.industry(name)} legacyBehavior>
          <a className="wrapper">
            <div className="icon">
              <Image
                src={icon.url}
                alt={icon.alt}
                style={{objectFit: 'contain'}}
                fill
                sizes="85px"
              />
            </div>
            <Text element="h3" align="center" fontWeight={TextFontWeight.bold}>
              {t(`${cardTitle}-${name}`)}
            </Text>
          </a>
        </Link>
      </li>

      <style jsx>{`
        .item {
          width: 100%;
          max-width: calc((100% / 5) - 16px);
          background-color: ${theme.palette.background.default};
          margin: ${theme.spacing[2]};
          box-shadow: 2px 3px 6px rgba(16, 24, 40, 0.1);
          transition: transform ${HOVER_TRANSITION}ms ease-in-out;
        }

        .item:hover {
          background-color: ${theme.palette.background.butterLight};
          transform: scale(1.0313);
        }

        .wrapper {
          display: inline-flex;
          flex-direction: column;
          justify-content: center;
          width: 100%;
          height: 100%;
          padding: ${theme.spacing[3]};
        }

        .icon {
          position: relative;
          width: 85px;
          height: 56px;
          margin: 0 auto ${theme.spacing[2]};
        }

        @media ${TABLET_SCREENSIZE} {
          .item {
            max-width: calc((100% / 3) - 16px);
          }
        }

        @media ${MOBILE_SCREENSIZE} {
          .item {
            flex: 1 0 180px;
            max-width: 180px;
          }

          .icon {
            height: 44px;
          }
        }
      `}</style>
    </>
  )
}
